module.exports = __webpack_public_path__ + "static/media/green_pressed.cb6b8602.png";